import {computed, readonly, ref} from 'vue'
import moment from 'moment'

type Props = {
  year?: number
  month?: number
  monthRange: number[]
  period?: number
}
type HandleChangeDateRangeProps = {
  value: number
  type: 'period' | 'month' | 'year'
}

export const useKkDateRangeSelect = (props: Props) => {
  const today = moment()
  const selectedYear = ref<number>(props.year ?? today.year())
  const selectedMonth = ref<number>(props.month ?? today.month() + 1)
  const selectedPeriod = ref<typeof props.monthRange[number]>(props.period ?? 12)
  const endDate = computed(() => {
    return moment(`${selectedYear.value}-${selectedMonth.value}`, 'YYYY-MM')
      .endOf('month')
      .format('YYYY-MM-DD')
  })
  const startDate = computed(() => {
    return moment(endDate.value)
      .subtract(selectedPeriod.value - 1, 'month')
      .startOf('month')
      .format('YYYY-MM-DD')
  })

  const setDateRange = ({value, type}: HandleChangeDateRangeProps) => {
    switch (type) {
    case 'period':
      selectedPeriod.value = value
      break
    case 'month':
      selectedMonth.value = value
      break
    case 'year':
      selectedYear.value = value
      break
    }
  }

  return {
    startDate: readonly(startDate),
    endDate: readonly(endDate),
    selectedYear: readonly(selectedYear),
    selectedMonth: readonly(selectedMonth),
    selectedPeriod: readonly(selectedPeriod),
    setDateRange,
  }
}
